import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const Homepage = Scrivito.provideObjClass("HomepageSame", {
  attributes: {
    ...defaultPageAttributes,
    childOrder: "referencelist",
    cookieConsentLink: "link",
    dividerLogo: ["reference", { only: ["Image"] }],
    facebookAppId: "string",
    footerWidgets: ["widgetlist", { only: "FooterContainerWidget" }],
    googleMapsApiKey: "string",
    headerSocialMediaLinks: [
      "referencelist",
      {
        only: [
          "YoutubeSocialHeaderButtonWidget",
          "XingSocialHeaderButtonWidget",
          "ViadeoSocialHeaderButtonWidget",
          "TwitterSocialHeaderButtonWidget",
          "LinkedInSocialHeaderButtonWidget",
          "InstagramSocialHeaderButtonWidget",
          "FacebookSocialHeaderButtonWidget",
        ],
      },
    ],
    navigationFooterLinks: "linklist",
    minimizedFooterLinks: "linklist",
    navigationServiceLinks: "linklist",
    configuratorNavigationServiceLinks: [
      "referencelist",
      { only: ["Homepage", "ProjectListSame", "ContentPage", "Redirect"] }, // TODO: "Redirect" is only temporary (for ISH presentation)
    ],
    configuratorNavTitle: "string",
    configuratorNavMenu: "string",
    configuratorNavLogin: "string",
    configuratorNavExit: "string",
    projectItemPage: ["reference", { only: ["ProjectItemSame"] }],
    projectConfiguratorPage: ["reference", { only: ["ProjectConfigurator"] }],
    productConfiguratorPage: ["reference", { only: ["ProductConfigurator"] }],
    productListPage: ["reference", { only: ["ProductList"] }],
    userListPage: ["reference", { only: ["UserList"] }],
    groupListPage: ["reference", { only: ["GroupList"] }],
    departmentListPage: ["reference", { only: ["DepartmentList"] }],
    configLeftSidebarProjectRefs: [
      "referencelist",
      {
        only: ["ProjectListSame", "ProjectItemSame", "ProjectConfigurator"],
      },
    ],
    configLeftSidebarProductsRefs: [
      "referencelist",
      {
        only: ["ProductConfigurator", "ProductList", "CustomProductItem"],
      },
    ],
    configLeftSidebarLibraryRefs: [
      "referencelist",
      {
        only: ["LibraryList", "LibraryTemplates", "LibraryCustom"],
      },
    ],
    configLeftSidebarAdminRefs: [
      "referencelist",
      {
        only: ["UserList", "GroupList", "DepartmentList"],
      },
    ],
    configLeftSidebarHelpRefs: ["referencelist", { only: ["ContentPage"] }],
    welcomePage: ["reference", { only: ["ProjectListSame"] }],
    logo: ["reference", { only: ["Image"] }],
    logoLink: "link",
    configuratorLogo: ["reference", { only: ["Image"] }],
    twitterSite: "string",
    mainNavigationSerialized: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: [],
});

export default Homepage;
